import { ErrorHandler, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { BrowserModule } from '@angular/platform-browser';
import { AgGridModule } from 'ag-grid-angular';
import { LicenseManager } from 'ag-grid-enterprise/main';
import { InlineSVGModule } from 'ng-inline-svg';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app.routing.module';
import { CatchingErrorsService } from './pages/A2-utils/ParentClass/catching-errors.service';
import { PagesModule } from './pages/pages.module';
import { RulesService } from './pages/rules/rules.service';
import { StandingOrderModule } from './pages/standing-order/standing-order.module';
import { CustomPreloadingService } from './services/custom-preloading.service';
import { EventBusCardService } from './services/event-bus-card.service';
import { ServicesModule } from './services/services.module';
import { VersionService } from './services/version/version.service';
import { T2LoadingService } from './trip2-theme/components/t2-loading/t2-loading.service';
import { Trip2ThemeModule } from './trip2-theme/trip2-theme.module';
import { CustomInterceptorService } from './core/services/custom-interceptor.service';
import { SweetAlertHelper } from './core/helpers/sweet-alert-helper.service';
import { ToastrModule } from 'ngx-toastr';
import { ToastrAlertHelper } from './core/helpers/toastr-alert-helper-service';
import { UserInfoHelperService } from './core/helpers/user-info-helper-service';
import { ValidateFileHelper } from './core/helpers/validate-file-helper.service';
import { AddressHelper } from './core/helpers/address-helper.service';
import { TripNotificationsService } from './services/trip-notifications.service';
import { SessionEventService } from './core/services/session-event.service';
import { ExcelExportService } from './core/services/excel-export.service';
import { CsvExportService } from './core/services/csv-export.service';
import { DataExportNotifierHelper } from './core/helpers/data-export-notifier.helper';


LicenseManager.setLicenseKey('');
LicenseManager['outputMessage'] = function () {};
// declare const firebase: any;

// firebase.initializeApp(environment.config_firebase);

@NgModule({
    declarations: [
      AppComponent,
    ],
    imports: [
        AgGridModule.withComponents([]),
        AppRoutingModule,
        BrowserModule,
        FormsModule,
        HttpModule,
        InlineSVGModule,
        Trip2ThemeModule,
        ServicesModule,
        PagesModule,
        StandingOrderModule,
        ToastrModule.forRoot(),
    ],
    providers: [
        {
            provide: ErrorHandler,
            useClass: CustomInterceptorService
        },
        T2LoadingService,
        VersionService,
        CatchingErrorsService,
        RulesService,
        EventBusCardService,
        CustomPreloadingService,
        SweetAlertHelper,
        ToastrAlertHelper,
        AddressHelper,
        UserInfoHelperService,
        ValidateFileHelper,
        TripNotificationsService,
        SessionEventService,
        ExcelExportService,
        CsvExportService,
        DataExportNotifierHelper
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts